export interface InventorySettings {
  update_inventory_price_from_invoice_quick_add_by_default: boolean;
  /** Show stock status update option when adding/editing invoice items */
  show_stock_status_update_in_invoice_item_add: boolean;
}

export interface InvoiceSettings {
  /** Send Automated Invoice Messages on Whatsapp */
  send_invoice_updates_on_whatsapp: boolean;
  /** Include free quantity field when adding invoice items */
  include_free_quantity_in_invoice_item_add: boolean;
  /** Include serial number field when adding invoice items */
  include_serial_number_in_invoice_item_add: boolean;
  /** Show UPI ID and payment link on web invoice to customers */
  show_upi_on_web_invoice: boolean;
  /** Show UPI QR code on printed invoices */
  show_qr_on_printed_invoice: boolean;
  /** Show customer ledger status on invoice */
  show_overall_dues_on_invoice: boolean;
  /** Print customer ledger status on printed invoices */
  print_overall_dues_on_invoice: boolean;
  /** Show online orders on store dashboard */
  online_order_on_dashboard: boolean;
}

export interface StoreConfig {
  inventory_settings: InventorySettings;
  invoice_settings: InvoiceSettings;
}

// Default store configuration object
export const DEFAULT_STORE_CONFIG: StoreConfig = {
  inventory_settings: {
    update_inventory_price_from_invoice_quick_add_by_default: false,
    show_stock_status_update_in_invoice_item_add: false
  },
  invoice_settings: {
    send_invoice_updates_on_whatsapp: false,
    include_free_quantity_in_invoice_item_add: false,
    include_serial_number_in_invoice_item_add: false,
    show_upi_on_web_invoice: true,
    show_qr_on_printed_invoice: true,
    show_overall_dues_on_invoice: true,
    print_overall_dues_on_invoice: false,
    online_order_on_dashboard: true
  }
};

/**
 * Merges partial store config with defaults, handling null/undefined cases
 * @param storeConfig - Partial store config from database or user input
 * @returns Complete StoreConfig with all fields populated
 */
export function mergeStoreConfig(storeConfig: Partial<StoreConfig> | null | undefined): StoreConfig {
  // Handle null/undefined cases
  if (!storeConfig) {
    return DEFAULT_STORE_CONFIG;
  }

  return {
    ...DEFAULT_STORE_CONFIG,
    inventory_settings: {
      ...DEFAULT_STORE_CONFIG.inventory_settings,
      ...(storeConfig.inventory_settings || {}),
    },
    invoice_settings: {
      ...DEFAULT_STORE_CONFIG.invoice_settings,
      ...(storeConfig.invoice_settings || {}),
    },
  };
}